import React from 'react';
import { Outlet, Link } from 'react-router-dom';

function DashboardLayout() {
  return (
    <div className="p-4 border rounded-lg shadow-md bg-white">
      <h2 className="text-2xl font-bold mb-4">Dashboard Layout</h2>
      <nav className="mb-4">
        <ul className="flex space-x-4">
          <li>
            <Link to="/dashboard" className="text-blue-600 hover:underline">Dashboard Overview</Link>
          </li>
          <li>
            <Link to="/dashboard/settings" className="text-blue-600 hover:underline">Dashboard Settings</Link>
          </li>
        </ul>
      </nav>
      <hr className="mb-4" />
      <Outlet />
    </div>
  );
}

export default DashboardLayout;